/**
 * Created by Majid on 1/29/2017.
 */
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PaymentLogCustom', PaymentLogCustom);

    PaymentLogCustom.$inject = ['$resource'];

    function PaymentLogCustom($resource) {


        var createPaymentLogByOrderBagId = function () {

            var resourceUrl = 'api/create-payment-log-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var deletePaymentLogById = function () {
            var resourceUrl = 'api/delete-payment-log/:id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var createPaymentLogByInvoiceInfoId = function () {

            var resourceUrl = 'api/create-payment-log-by-invoice-info-id';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {
            createPaymentLogByOrderBagId: createPaymentLogByOrderBagId,
            deletePaymentLogById: deletePaymentLogById,
            createPaymentLogByInvoiceInfoId: createPaymentLogByInvoiceInfoId
        };
    }
})();

